import { Component } from '@angular/core';
import { Subscription } from 'rxjs';
import { UserService } from './user.service';
import { ChatService } from './chat.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'bsf444';
  isLogin = false;
  level: string;
  userId = '';
  private authListenerSubs: Subscription;
  constructor(private userService: UserService, private chatService: ChatService) { }

  ngOnInit() {
    // this.chatService.getMessages();
    // this.chatService.getUpdateMessageListner().subscribe((response) => {
    //   console.log(response);
    // });

    this.userService.autoAuthUser();
    this.isLogin = this.userService.getIsAuth();
   
    this.authListenerSubs = this.userService
    .getAuthStatusListner()
    .subscribe((IsAuthenticated) => {
        this.isLogin = IsAuthenticated;          
    }); 
  }
 
  ngOnDestroy() {
    this.authListenerSubs.unsubscribe();  
  }
}